// extracted by mini-css-extract-plugin
export default {"customValue":"CustomValue_customValue__YDeZQ","width":"CustomValue_width__DJa5n"};